import React from 'react'
import { NavLink } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ReactComponent as KandorLogoShort } from '../../assets/kandor_logo_short.svg'
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg'
import { ReactComponent as SettingsIcon } from '../../assets/icons/settings.svg'
import { ROUTES } from '../../shared/config/routes'
import s from './styles/Sidebar.module.scss'
import { useSidebar } from './hooks/useSidebar'

function renderNavIcon(item) {
	if (item.isMaterial) {
		return <span className="material-icons-outlined">{item.icon}</span>
	}
	return item.icon
}

export const Sidebar = observer(function Sidebar() {
	const { navItems, footerNavItems, handleLogout } = useSidebar()

	return (
		<aside className={s.sidebar}>
			<div className={s.inner}>
				{/* Kandor Logo */}
				<div className={s.logo}>
					<div className={s.logo__inner}>
						<span className={s.logo__icon}>
							<KandorLogoShort />
						</span>
						<span className={s.logo__text}>Kandor</span>
					</div>
				</div>

				{/* Navigation */}
				<nav className={s.nav}>
					{navItems.map(item => (
						<NavLink
							key={item.to}
							to={item.to}
							end={item.end}
							className={({ isActive }) =>
								`${s.navItem} ${isActive ? s.active : ''}`
							}
						>
							<span className={`${s.navItem__icon} ${item.iconClass ? s[item.iconClass] : ''}`}>
								{renderNavIcon(item)}
								{item.badgeText ? (
									<span className={s.navItem__badge}>{item.badgeText}</span>
								) : null}
							</span>
							<span className={s.navItem__text}>{item.label}</span>
						</NavLink>
					))}
				</nav>
			</div>

			<div className={s.footer}>
				{footerNavItems.map(item => (
					<NavLink
						key={item.to}
						to={item.to}
						end={item.end}
						className={({ isActive }) =>
							`${s.navItem} ${isActive ? s.active : ''}`
						}
					>
						<span className={`${s.navItem__icon} ${item.iconClass ? s[item.iconClass] : ''}`}>
							{renderNavIcon(item)}
						</span>
						<span className={s.navItem__text}>{item.label}</span>
					</NavLink>
				))}

				<NavLink
					to={ROUTES.SETTINGS}
					className={({ isActive }) =>
						`${s.settingsLink} ${isActive ? s.settingsLinkActive : ''}`
					}
					aria-label="Settings"
				>
					<span className={s.settingsLink__icon}>
						<SettingsIcon />
					</span>
					<span className={s.settingsLink__text}>Settings</span>
				</NavLink>

				<button
					onClick={handleLogout}
					className={`${s.navItem} ${s.settings}`}
					aria-label="Logout"
					type="button"
				>
					<span className={`${s.navItem__icon} ${s.logoutIcon}`}>
						<LogoutIcon />
					</span>
					<span className={s.navItem__text}>Log out</span>
				</button>
			</div>
		</aside>
	)
})
